import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthDataService } from '../services/auth-data.service';
import { TokenService } from '../services/token.service';
import { Router } from '@angular/router';
/**
 *
 * Guard para acceder a los modulos solo si el usuario esta autenticado
 *
 * TODO: Modificar el codigo cuando se tenga el inicio de sesión
 *
 *
 * @export
 * @class AuthGuard
 * @implements {CanActivate}
 * @author Sebastian C
 */

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authDataService: AuthDataService,
    private tokenService: TokenService,
    private router: Router
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this.authDataService.getToken();
    if (!token) {
      this.authDataService.logout();
      return false;
    }

    const tokenPayload = this.tokenService.decodeToken(token);

    const expirationDate = new Date((tokenPayload.exp || 0) * 1000);
    if (new Date() >= expirationDate) {
      this.authDataService.logout();
      return true;
    }

    return true;
  }
}
